@if (activation(); as currentActivation) {
  <button
    type="button"
    class="activation-button"
    [attr.data-gate]="currentActivation.gate"
    [title]="transitTooltip()"
    (click)="handleClick($event)"
    (contextmenu)="handleContextMenu($event)"
    (mouseenter)="handleMouseEnter()"
    (mouseleave)="handleMouseLeave()"
  >
    <span class="gate-line">
      <span class="gate">{{ currentActivation.gate }}</span><span class="dot">.</span><span class="line">{{ currentActivation.line }}</span>
    </span>
    <span class="arrows arrows--base">
      @if (showExaltationArrow()) {
        <span class="arrow arrow--exaltation">▲</span>
      }
      @if (showDetrimentArrow()) {
        <span class="arrow arrow--detriment">▼</span>
      }
    </span>
    <span class="arrows arrows--transit" [title]="transitTooltip()">
      @if (showTransitExaltationArrow()) {
        <span class="arrow arrow--transit arrow--exaltation">▲</span>
      }
      @if (showTransitDetrimentArrow()) {
        <span class="arrow arrow--transit arrow--detriment">▼</span>
      }
    </span>
  </button>
}
